import React from 'react';
import memoizeOne from 'memoize-one';
import { connect } from '../../components/runtime-context';

export const createPageLink = memoizeOne(
  (createPageUrl, handleNavigation = () => {}) => {
    const PageLink = ({
      children,
      page,
      isDisabled,
      isActive,
      navigateInPreview,
      ...props
    }) => {
      if (isActive || isDisabled) {
        return <div {...props}>{children}</div>;
      }
      const pageUrl = createPageUrl(page);
      return (
        <a
          href={pageUrl}
          onClick={(event) =>
            handleNavigation({
              event,
              pageUrl,
              navigateInPreview,
            })
          }
          {...props}
        >
          {children}
        </a>
      );
    };

    const mapRuntimeToProps = (state, _ownProps, actions) => ({
      navigateInPreview: actions.navigateInPreview,
    });

    return connect(mapRuntimeToProps)(PageLink);
  },
);
